import React, { useEffect} from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/FinancePageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import { FiExternalLink } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {  useNavigate, useParams } from "react-router";
import { GetSingleFuelRequest,ApproveFuelRequest,DeclineFuelRequest} from "../../../../../utils/redux/Fleet/FleetSlice";
import { PageActions,TableActionsDownload } from "../../../Components/Misc/Actions";
import Table from "../../../Components/Table/Table";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useApprovals } from "../../Fleets/Requisition/RequisitionApproval/useApproval";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import RouteLayout from "../../../Components/Layout/RouteLayout";
import styleJS from "./styleJS";
import { IoArrowBackOutline } from "react-icons/io5";
import { GetCostService, setEditData, setEditMode } from "../../../../../utils/redux/Finance/CostCenterSlice/CostCenterSlice";
import { getStatusText } from "./Class";

export function getDurationText(num){
  return num === 1? "Monthly": num === 2? "Quarterly": num === 3? "Annually" : null;
}

function CostCenterDetails() {
  const { SelectedService:request, GlobalData: {Branches}  } = useSelector(state=> state.costCenter);
  console.log({ request });

  const navigate = useNavigate();
  const formMethods = useForm({
    mode: "all",
  });
  const {
    handleSubmit,
  } = formMethods;

  const submit = (e) => {
    alert("clicked");
  };
  const dispatch = useDispatch();

  // const {id} = useParams() 
  // useEffect(()=>{
  //   dispatch(GetCostService(id))
  // },[id])
 
  let backBtn = (
    <div>
      <button onClick={() => navigate(-1)} className={`rounded-lg border-solid border-[1px] border-[#A0BDA2] p-4 py-3 flex space-x-[10px] text-[#4B664C] text-[13px] font-[600]`}>
        <IoArrowBackOutline className={`text-[20px]`} />
        <p>Back</p>
      </button>
    </div>
  )

  let EmployeeContainer = Branches?.find(B=> B.id === request?.employee?.containerId);

  // const { openModal,closeModal } = useApprovals({});
  return (
    <RouteLayout>
        <PageLayout title={"Cost Center Service Details"} backBtn={backBtn}>
        <FormProvider {...formMethods}>
            <FormTemplate className={DashboardStyle.view_app_components} handleSubmit={handleSubmit(submit)}>
            <section  style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
              }} className={DashboardStyle.form_section}
            >
                <h4 className={DashboardStyle.form_section_title}>
                    Basic<br/> Information
                </h4>
                <div className={DashboardStyle.labels_group}>
                  <div>
                      {request.organizationStructure===1 &&
                      <div>
                          <p>Individual:</p>
                          <h4>{request?.employees}</h4>
                      </div>}
                      {request.organizationStructure===1 &&
                      <div>
                          <p>Position:</p>
                          <h4>{request?.positions}</h4>
                      </div>}
                      {request.organizationStructure===2?
                      <div>
                          <p>Cadre:</p>
                          <h4>{request?.cadre}</h4>
                      </div>
                      : null}
                      {request.organizationStructure===3?
                      <div>
                          <p>Department</p>
                          <h4>{request?.department?.name}</h4>
                      </div>
                      : null}

                      {request.organizationStructure===4?
                      <div>
                          <p>Branch</p>
                          <h4>{request?.branch}</h4>
                      </div>
                      : null}
                      <div>
                          <p>Cost Class</p>
                          <h4>{request?.costClass?.name}</h4>
                      </div>
                  </div>
                  <div>
                      <div>
                          <p>Limit:</p>
                          <h4>{FormatCurrency(request?.limit)}</h4>
                      </div>
                      <div>
                          <p>Chart of Account</p>
                          <h4>{request?.chartofAccountSetup?.groupName}</h4>
                      </div>
                      <div>
                          <p>Duration:</p>
                          <h4>{request?.duration}</h4>
                      </div>
                  </div>
                  <div>
                    <div>
                      <p>Approval</p>
                      <h4>{getStatusText(request?.status)}</h4>
                    </div>
                  </div>
                </div>
            </section>
            <section className={``}>
                <button onClick={(e)=>{e.preventDefault(); dispatch(GetCostService(request?.id)).then(response=> dispatch(setEditMode(true))); navigate('../Setup'); }} className={styleJS.details.editActionButton}>
                    Edit
                </button>
            </section>
            </FormTemplate>
        </FormProvider>
        </PageLayout>
    </RouteLayout>
  );
}

export default CostCenterDetails;